import { Pipe, PipeTransform } from '@angular/core';
import {
  enumLabel,
  enumNumber,
  TimeTrackingDefaultType,
  TimeTrackingDefaultTypeSchema,
  TimeTrackingTaskType,
} from '@vmspdb/definitions';

@Pipe({
  name: 'timeTrackingTask',
  standalone: false,
})
export class TimeTrackingTaskPipe implements PipeTransform {
  transform(value: TimeTrackingTaskType | undefined): string {
    if (!value) {
      return '';
    }

    return enumNumber(TimeTrackingDefaultTypeSchema, value.default) ===
      TimeTrackingDefaultType.UNSPECIFIED
      ? (value.custom?.text ?? '')
      : enumLabel(TimeTrackingDefaultTypeSchema, value.default);
  }
}
